import { LetPassAccountSearchCriteria } from "domain/entity/LetPassAccount/LetPassAccountSearchCriteria";
import { ActiveIndDroOpts } from "presentation/constant/DropDownOptions/Common/ActiveIndDroOpts";
import { LetPassAccountConstant } from "presentation/constant/LetPassAccount/LetPassAccountConstant";
import { useLetPassAccountVM } from "presentation/hook/LetPassAccount/useLetPassAccountVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useLetPassAccountTracked } from "presentation/store/LetPassAccount/LetPassAccountProvider";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";
import DateRangePickerComponent from "presentation/view/components/DateRangePickerComponent";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IconButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, Sidebarheader, SidebarTitle } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const LetPassAccountSearchPanel = () => {
    const SCREEN_CONSTANT = LetPassAccountConstant;
    const [letPassAccountState] = useLetPassAccountTracked();
    const letPassAccountVM = useLetPassAccountVM();
    const { searchCriteria } = letPassAccountState;
    const [isLoading, setIsLoading] = useState(false);
    const messageBarVM = useMessageBarVM();

    const resetButtonClicked = useCallback(() => {
        letPassAccountVM.onRemoveAllSearchCriteria();
    }, [letPassAccountVM]);

    const searchButtonClicked = useCallback((searchCriteria: LetPassAccountSearchCriteria) => {

        if (!searchCriteria.companyCode) {
            messageBarVM.showError("Please input CC Company Code to search.");
            return;
        }
        setIsLoading(true);
        letPassAccountVM.onSearch(searchCriteria).then((data) => {
            setIsLoading(false);
        }).catch(error => {
            setIsLoading(false);
        })

    }, [letPassAccountVM, messageBarVM])


    const memoCompanyCode = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.companyCode ?? ''}
                fieldValue={searchCriteria?.companyCode}
                fieldLabel={SCREEN_CONSTANT.CC_COMPANY_CODE}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'companyCode'}
                maxLength={60}
                isLimitOptions={true}
                options={letPassAccountState.dynamicOptions.companyCodeDropdownOptions}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.companyCode, SCREEN_CONSTANT.CC_COMPANY_CODE, letPassAccountState.dynamicOptions.companyCodeDropdownOptions, letPassAccountVM])

    const memoActiveInd = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px" }}>
            <NbisCommonField
                errorMessages={{}}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={searchCriteria?.activeInd ?? ''}
                fieldValue={searchCriteria?.activeInd}
                fieldLabel={SCREEN_CONSTANT.ACTIVE_IND}
                isSaveClicked={false}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'activeInd'}
                maxLength={60}
                options={ActiveIndDroOpts().getDroOptsModel()}
                requiredFieldList={[]}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    letPassAccountVM.onSearchFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [searchCriteria?.activeInd, SCREEN_CONSTANT.ACTIVE_IND, letPassAccountVM])


    const memoTransactionDateFromTo = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "470px", marginBottom: "24px" }}>
            <DateRangePickerComponent
                label={SCREEN_CONSTANT.TRANSACTION_DATE_RANGE}
                width='470px'
                fieldNames={{ startField: "transactionDateFrom", endField: "transactionDateTo" }}
                dateRange={{ startDate: searchCriteria.transactionDateFrom, endDate: searchCriteria.transactionDateTo }}
                onDatesChange={letPassAccountVM.onDateRangeChange}
            />
        </div>
        , [SCREEN_CONSTANT.TRANSACTION_DATE_RANGE, letPassAccountVM.onDateRangeChange, searchCriteria.transactionDateFrom, searchCriteria.transactionDateTo])

    return (
        <div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{SCREEN_CONSTANT.SEARCH_CRITERIA}</SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={letPassAccountVM.onSearchClick} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>

            {isLoading && <Loader Indicator="Spinner" size="Medium" />}

            <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>


                        <CriteriaItemContainer>
                            {memoCompanyCode}
                            {memoActiveInd}
                        </CriteriaItemContainer>

                        <CriteriaItemContainer>
                            {memoTransactionDateFromTo}
                        </CriteriaItemContainer>

                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Reset'} size={'Small'} theme={'Secondary'} onClick={resetButtonClicked} />
                <HPHButton label={'Search'} size={'Small'} theme={'Primary'} onClick={() => searchButtonClicked(searchCriteria)} />
            </SidebarActionBar>
        </div>
    );
}

export default LetPassAccountSearchPanel;
